import script from "./NVI.vue?vue&type=script&lang=js"
export * from "./NVI.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__